import { render, staticRenderFns } from "./EditableColumnTypeDropdown.vue?vue&type=template&id=2db2343d&scoped=true&"
import script from "./EditableColumnTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./EditableColumnTypeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2343d",
  null
  
)

export default component.exports